import React from "react";
import "./App.css";
import Home from "./frontend/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Academics from "./frontend/Academics";
import Miscellaneous from "./frontend/Miscellaneous";
import ExtraCurricular from "./frontend/ExtraCurricular";

function App() {
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route path="/academics">
            <Academics />
          </Route>
          <Route path="/extra-curricular">
            <ExtraCurricular />
          </Route>
          <Route path="/miscellaneous">
            <Miscellaneous />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;
